/* eslint-disable no-underscore-dangle */
import { getAccessToken } from '@core-frontend/core-frontend';
import type { InternalAxiosRequestConfig } from 'axios';
import axios from 'axios';

import { refreshTokenAndUpdateStore } from '@/pages/auth/model';

import { getXhostHeader } from '@/shared/lib/domain';
import { env } from '@/shared/lib/env';

interface CustomAxiosRequestConfig extends InternalAxiosRequestConfig {
  _retry?: boolean;
}
const API_URL_HTTP = `${env.VITE_API_URL}/api/v1`;

const COMMON_HEADERS = {
  'X-HOST': getXhostHeader(),
};

const baseClient = axios.create({
  baseURL: API_URL_HTTP,
  timeout: import.meta.env.DEV ? 20000 : 60000,
  headers: COMMON_HEADERS,
});

baseClient.interceptors.request.use((req) => {
  const accessToken = getAccessToken();
  if (accessToken) {
    req.headers.Authorization = `Bearer ${accessToken}`;
  }
  return req;
});

baseClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config as CustomAxiosRequestConfig;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const newAccessToken = await refreshTokenAndUpdateStore();
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return await baseClient(originalRequest);
      } catch {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export { baseClient };
